import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {ContractsRuntimeDto, ContractsRuntimeInsuranceDto} from "../../types/contracts.types";
import {Router} from "@angular/router";


@Component({
  selector: 'app-contracts-browse',
  templateUrl: './contracts-browse.component.html',
  styleUrls: ['contracts-browse.component.scss']
})
export class ContractsBrowseComponent extends CoreComponent implements OnInit {

  // @Input() contractsRuntime!: ContractsRuntimeDto;
  @Input() uiContracts: ContractsRuntimeInsuranceDto[] | undefined = [];
  @Input() source?: string;

  // uiContracts: ContractsRuntimeInsuranceDto[] | undefined;

  constructor(protected router: Router) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    this.refreshComponent();
  }


  // refreshComponent() {
  //   this.uiContracts = this.uiContracts?.filter(item => item.notFullyManaged == false);
  //   this.initialized = true;
  // }

  refreshComponent() {
    // 1) Filter out “not fully managed” items
    this.uiContracts = this.uiContracts
      ?.filter(item => !item.notFullyManaged)
      // 2) Sort alphabetically A→Z by insuranceCompany.name
      .sort((a, b) =>
        a?.insuranceCompany?.name.localeCompare(b?.insuranceCompany?.name)
      );

    this.initialized = true;
  }

  showContract(contract: ContractsRuntimeInsuranceDto) {

    this.router.navigate(['/ds/contract', contract.id, this.source]);

  }


  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    if (!this.initialized) {
      return;
    }
    this.refreshComponent();

  }

}
